const Form = ({
  handleYurtTraitChange,
  trait,
  pixels,
  editYurt,
  handleEditYurt,
  stackEdit,
  handleStackEdit,
  printAll,
  walls,
  handleMasterWallChange,
}) => {
  const windowHeaderSum = (e, k) => {
    const arr = [];
    walls.forEach((e) => {
      if (e.windows) {
        arr.push(e);
      }
    });
    if (arr.length) {
      return (
        [...arr]
          .sort(
            (a, b) =>
              arr.filter((v) => v[e][k] === a[e][k]).length -
              arr.filter((v) => v[e][k] === b[e][k])
          )
          .pop()[e][k] / pixels
      );
    }

    return "null";
  };

  const doorHeaderSum = (k) => {
    const arr = [];
    walls.forEach((e) => {
      if (e.doors) {
        arr.push(e);
      }
    });
    if (arr.length) {
      return (
        [...arr]
          .sort(
            (a, b) =>
              arr.filter((v) => v[k] === a[k]).length -
              arr.filter((v) => v[k] === b[k])
          )
          .pop()[k] / pixels
      );
    }
    return "null";
  };

  const handleHeaderChange = (e) => {
    if (e.target.parentElement.id === "doors") {
      const value = e.target.value;
      const name = e.target.name;

      handleMasterWallChange("doors", name, value);
    } else {
      const value = e.target.value;
      const name = e.target.name;
      const options = ["window1", "window2"];

      options.forEach((o) => handleMasterWallChange(o, name, value));
    }
  };

  return (
    <div>
      <div
        id="yurt-edit-button"
        onClick={() => handleEditYurt()}
        style={{
          background: editYurt ? "orange" : "",
          color: editYurt ? "white" : "",
        }}
      >
        {editYurt ? "Editing" : "Edit"}
      </div>
      <div
        id="stack-edit-button"
        onClick={() => handleStackEdit()}
        style={{
          background: stackEdit ? "blue" : "",
          color: stackEdit ? "white" : "",
        }}
      >
        {stackEdit ? "Stack Building" : "Stack Build"}
      </div>
      <div
        id="print-all-button"
        className="btn btn-outline-dark w-100 p-2"
        style={{ display: editYurt ? "none" : "" }}
        onClick={printAll}
      >
        Print All
      </div>
      <div
        id="main-yurt-edit-options"
        style={{ display: editYurt ? "" : "none" }}
      >
        <label>Name</label>
        <input
          onChange={(e) => handleYurtTraitChange(e)}
          className="form-control mb-3"
          defaultValue={trait.kitName}
          name="kitName"
        ></input>
        <label>Kit Size</label>
        <select
          onChange={(e) => handleYurtTraitChange(e)}
          defaultValue={trait.size}
          className="form-control mb-3"
          name="size"
        >
          <option value="16">20'</option>
          <option value="20">25'</option>
          <option value="24">30'</option>
          <option value="27">35'</option>
          <option value="32">41'</option>
        </select>
        <label>Wall Height</label>
        <select
          name="h"
          className="form-control mb-3"
          onChange={(e) => handleYurtTraitChange(e)}
          defaultValue={trait.h / pixels}
        >
          <option value="96">8'</option>
          <option value="108">9'</option>
          <option value="120">10'</option>
          <option value="132">11'</option>
          <option value="144">12'</option>
          <option value="156">13'</option>
          <option value="168">14'</option>
          <option value="180">15'</option>
        </select>
        <label>Bottom Plate</label>
        <select
          name="bottomPlate"
          className="form-control mb-3"
          onChange={(e) => handleYurtTraitChange(e)}
          defaultValue={trait.bottomPlate}
        >
          <option value="FIR">FIR</option>
          <option value="CEDAR">CEDAR</option>
        </select>
        <label>Eaves</label>
        <select
          name="eaves"
          className="form-control mb-3"
          onChange={(e) => handleYurtTraitChange(e)}
          defaultValue={trait.eaves}
        >
          <option value="16">16"</option>
          <option value="24">24"</option>
        </select>
        <label>Stud Spacing</label>
        <select
          name="stud"
          className="form-control mb-3"
          onChange={(e) => handleYurtTraitChange(e)}
          defaultValue={trait.stud / pixels}
        >
          <option value="16">16"</option>
          <option value="24">24"</option>
        </select>
        <label>Nailing Pattern</label>
        <input
          name="nailingPattern"
          className="form-control mb-3"
          onChange={(e) => handleYurtTraitChange(e)}
          defaultValue={trait.nailingPattern}
        />
        <div id="windows">
          <label>Header 1</label>
          <select
            className="form-control mb-3"
            name="header"
            id="windows"
            onChange={(e) => handleHeaderChange(e)}
            defaultValue={`${windowHeaderSum("window1", "header")}`}
          >
            <option value="0">UNSET</option>
            <option value="5.5">2 x 6</option>
            <option value="7.25">2 x 8</option>
            <option value="9.25">2 x 10</option>
            <option value="11.25">2 x 12</option>
          </select>
          <select
            className="form-control mb-3"
            name="headerAmount"
            onChange={(e) => handleHeaderChange(e)}
            defaultValue={`${windowHeaderSum("window1", "headerAmount")}`}
          >
            <option value="0">SINGLE</option>
            <option value="1">DOUBLE</option>
            <option value="2">TRIPLE</option>
          </select>
          {/* <select
            className="form-control mb-3"
            name="headerType"
            id="windows"
            onChange={(e) => handleHeaderChange(e)}
            defaultValue={`${windowHeaderSum("window1", "headerType")}`}
          >
            <option>FIR</option>
            <option>LVL</option>
          </select> */}
        </div>
        <div id="doors">
          <label>Header 2</label>
          <select
            className="form-control mb-3"
            name="header"
            onChange={(e) => handleHeaderChange(e)}
            defaultValue={`${doorHeaderSum("header")}`}
          >
            <option value="5.5">2 x 6</option>
            <option value="7.25">2 x 8</option>
            <option value="9.25">2 x 10</option>
            <option value="11.25">2 x 12</option>
          </select>
          <select
            className="form-control mb-3"
            name="headerAmount"
            onChange={(e) => handleHeaderChange(e)}
            defaultValue={`${doorHeaderSum("headerAmount")}`}
          >
            <option value="0">SINGLE</option>
            <option value="1">DOUBLE</option>
            <option value="2">TRIPLE</option>
          </select>
          {/* <select
            className="form-control mb-3"
            name="headerType"
            id="windows"
            onChange={(e) => handleHeaderChange(e)}
            defaultValue={`${windowHeaderSum("headerType")}`}
          >
            <option>FIR</option>
            <option>LVL</option>
          </select> */}
        </div>

        <label>Turn</label>
        <input
          defaultValue={trait.placement}
          type="range"
          min="0"
          name="placement"
          max={trait.size}
          onChange={(e) => handleYurtTraitChange(e)}
          step="1"
          className="mb-3"
        />
        <label>All Notes</label>
        <textarea
          defaultValue={trait.allNotes}
          name="allNotes"
          className="form-control"
          onChange={(e) => handleYurtTraitChange(e)}
        />
      </div>
    </div>
  );
};

export default Form;
